import { useTranslation } from "react-i18next";

import { LanguageSelector } from "components/LanguageSelector";

import kentaLogo from "assets/KENTA_4.0.png";

import { Container, Content, LogoContainer, LanguageSelectorWrapper, Subtitle } from "./styles";

const InviteRoomFinished = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <LanguageSelectorWrapper>
        <LanguageSelector />
      </LanguageSelectorWrapper>
      <Content>
        <LogoContainer>
          <img src={kentaLogo} alt="Logo da Empresa" width={240} height={90} />
        </LogoContainer>
        <Subtitle>{t("audiences.messages.participationFinished")}</Subtitle>
      </Content>
    </Container>
  );
};

export default InviteRoomFinished;
